import SmartBrowserFormModal from '@Components/NavigationContentDrawer/SmartBrowserFormModal/SmartBrowserFormModal';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components/native';

import useSmartBrowserPresenter from '../../NavigationContentDrawer/Panels/PrimaryNavigationColumn/SmartBrowser/SmartBrowser.presenter';

const StyledLoginOverlay = styled.View`
  position: absolute;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

const SmartBrowserOverlay: FC = () => {
  const { smartBrowserDialogOpen } = useSmartBrowserPresenter();

  if (!smartBrowserDialogOpen) {
    return null;
  }

  return (
    <StyledLoginOverlay>
      <SmartBrowserFormModal />
    </StyledLoginOverlay>
  );
};

export default observer(SmartBrowserOverlay);
